/** AddAppt/UpdateAppt errorCode values (SVPAPRE0 ITDRIH codes). */
export const APPT_ERROR_CODE = {
    RECORD_UPDATE_FAILED: '14',
} as const;

/** AddAppt/UpdateAppt errorMsg values passed through from SVPCUST0. */
export const APPT_ERROR_MSG = {
    COMPANY_FOUND: 'Company found',
} as const;
